<template>
  <div :class="moduleClass"
       :ref="module.route.module"
       class="module"
       style="border-radius: 15px; width:95%"
       @click="pushModuleRoute">
    <v-row class="m-0">

      <v-col class="py-3 px-0">
        <module-header :module="module" @addItem="addItem"></module-header>
        <div v-if="hasItems" :style="height != null ? 'min-height: 200px;' : 'min-height: 100px'">
          <v-col v-for="(item, key) in moduleItems" :key="key" class="module-card-list" @click="pushItemRoute(item)">
            <module-list-item :module="module" :item="item"></module-list-item>
          </v-col>
        </div>
        <div v-else class="col-12 p-0">
          <component :is="html" v-bind="props" :onClick="htmlEvent"></component>
        </div>
        <v-row class="m-0">
          <div v-for="(item, index) in module.actions" :key="index" class="pe-4">
            <loader-button :label="item.label" @callback="action(item)"></loader-button>
          </div>
        </v-row>
      </v-col>
    </v-row>

  </div>
</template>

<script lang="ts">
import Module, { ModuleItem } from '@/generated/classes/Module';
import NotificationBellWithCounter from '@/framework/notif/components/NotificationBellWithCounter.vue';
import { CiRouter, goToModule } from '@/framework/base/helpers/NavHelper';
import { kebab } from '@/framework/base/helpers/String';
import ModuleHeader from '@/framework/module/components/ModuleHeader.vue';
import ModuleListItem from "@/framework/module/components/ModuleListItem.vue";
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import { defineComponent, type PropType } from "vue";
import {useRoute, useRouter} from "vue-router";

export default defineComponent({
  components: {
    ModuleHeader,
    NotificationBellWithCounter,
    ModuleListItem,
    LoaderButton
  },
  props: {
    module: {
      type: Object as PropType<Module>,
      required: true
    },
    picto: {
      type: String
    },
    small: {
      type: Boolean
    },
    html: {
      type: Object as PropType<any>
    },
    htmlProps: {
      type: Object as PropType<any>
    },
    htmlClick: {
      type: Function,
      required: true
    },
    hasTitle: {
      type: Boolean
    },
    height: {
      type: Number,
    }
  },
  computed: {
    hasItems(): boolean {
      return this.module.items && this.module.items.length > 0;
    },
    colItems(): string {
      return this.small ? 'col-12' : 'col-12 col-md-6';
    },
    moduleItems(): ModuleItem[] {
      const res: ModuleItem[] = [];
      for (let i = 0; i < this.module.items.length; i++) {
        res.push(this.module.items[i]);
      }
      return res;
    },
    moduleClass(): string {
      return 'module-' + kebab(this.module.route.module);
    },
    props(): any {
      return this.htmlProps;
    }
  },
  data() {
    return {
      router: useRouter(),
      route: useRoute()
    }
  },
  methods: {
    htmlEvent(value: string): any {
      return this.htmlClick(this.module, value);
    },
    pushModuleRoute() {
      if (event != undefined) {
        event.stopPropagation();
      }
      goToModule(this.router, this.module.treeItem.route);
    },
    pushItemRoute(item: ModuleItem) {
      if (event != undefined) {
        event.stopPropagation();
      }
      if (item.route.isDialog) {
        CiRouter.addRoute(item.route);
      } else {
        goToModule(this.router, item.route);
      }
    },
    addItem(module: Module): void {
      if (event != undefined) {
        event.stopPropagation();
      }
      goToModule(this.router, module.add.route);
    },
    action(action: ModuleItem): void {
      if (event != undefined) {
        event.stopPropagation();
      }
      if (action.route.isDialog) {
        CiRouter.addRoute(action.route);
      } else {
        goToModule(this.router, action.route);
      }
    }
  }
})

</script>

<style scoped>
.module-card-list {
  padding: 10px 24px 10px 24px !important;
}

.module-card-list:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.1);
}

.module:hover {
  cursor: pointer;
}
</style>